import { render } from "./PasswordForgotten.vue?vue&type=template&id=600ca5da"
import script from "./PasswordForgotten.vue?vue&type=script&lang=js"
export * from "./PasswordForgotten.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/public/PasswordForgotten.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "600ca5da"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('600ca5da', __exports__)) {
    api.reload('600ca5da', __exports__)
  }
  
  module.hot.accept("./PasswordForgotten.vue?vue&type=template&id=600ca5da", () => {
    api.rerender('600ca5da', render)
  })

}


export default __exports__